import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "従業状況の登録確認",
  "退職した月以前6ヶ月の本俸月額登録",
  "退職手当金請求の順番登録",
  "源泉徴収票の登録",
  "登録内容の確認",
  "機構へ提出",
];

// 帳票種別（退職書類）
export enum FormClassRetirePats {
  "現認証明書（傷病）" = "8",
  "労働者災害補償保険の「障害補償給付又は傷病補償年金の支給決定通知書」 (写)" = "11",
  "障害厚生年金の受給を証する書類等" = "12",
  "現認証明書（死亡）" = "9",
  "「死亡診断書又は死体検案書」(写)" = "13",
  "「葬祭料(葬祭給付)の支給決定通知書」(写)又は「第三者行為災害届」(写)(労基署受理のもの)" = "44",
  "生計維持に関する調査書（戸籍上の配偶者が請求者となる場合は不要）" = "10",
  "問題行為の概要がわかる書類" = "15",
  "懲戒処分・解雇の辞令(写) " = "16",
  "解雇等処分について審議された議事録(写) " = "17",
  "就業規則(写) " = "5",
  "処分対象者の答弁が含まれる記録（写）、自認書（写）等" = "18",
  "判決書（写）" = "19",
  "新聞記事（写）" = "20",
  "その他当機構が求めた書類" = "6",
}

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者（法人）名",
    keyword: "contractorName",
    type: "text",
    showLine: false,
  },
  {
    title: "",
    keyword: "title",
    type: "lineTitle",
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "text",
  },
];

const fakeTableListField: ITkFakeTableLineProps[] = [
  {
    title: "退職理由",
    keyword: "retireReason",
    type: "text",
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass8",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass11",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass12",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass9",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass13",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass44",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass10",
    node: <></>,
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass15",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass16",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass17",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass5",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass18",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: false,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass19",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: false,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass20",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: false,
    showLine: false,
  },
  {
    title: "添付ファイル",
    keyword: "uploadFormClass6",
    node: <></>,
    type: "nodeInLine",
    requiredIcon: false,
    showLine: false,
  },
];

const schema = {
  prefectureRetirementJoinFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { fakeTableList, fakeTableListField, schema, stepper };
